import React from 'react';
import MileageSignupEligibilityBottomSheetImsiKr from '@di-shared/features/home/kr/benefit/MileageSignupEligibilityBottomSheetImsi.kr';

/**
 * [2026-02-09:Jeyoung Lee] FIXME: 서울시 임시 페이지
 * @link https://hmg.atlassian.net/browse/DRIVINGINS-2884
 */
function MileageSignupEligibilityImsiBottomSheetPage() {
  return <MileageSignupEligibilityBottomSheetImsiKr />;
}

export default MileageSignupEligibilityImsiBottomSheetPage;
